// Module
var code = "<h2 class=\"interiorSectionHeading\"> Borrower Defense Loan Discharge </h2> <p>You may qualify for discharge of your federal student loans if you attended a school that misled you or engaged in other misconduct in violation of certain laws.</p> ";
// Exports
export default code;